import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { Agency } from "../../../../models/interfaces";

import { CommonModule } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { BtnComponent } from "../../../ui/buttons/btn/btn.component";
import { DIALOG_CANCEL_BTN_CONFIG, DIALOG_CONFIRM_BTN_CONFIG } from "../../../../constants/dialog-buttons.constants";

@Component({
    selector: 'app-dialog-choose-agency',
    imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatIcon,
    BtnComponent,
    CommonModule
],
    template: `
    <h2 mat-dialog-title class="dialog-title">
      Choisir mon agence
    </h2>
    <mat-dialog-content class="dialog-content">
      <div class="content-wrapper">
        <div class="info-section">
          <p class="info-text">Votre organisation compte plusieurs agences.</p>
          <p class="sub-text">Choisissez votre agence de rattachement : vous retrouverez ensuite les données de votre équipe.</p>
        </div>
        
        <div class="agencies-grid">
          @for (agency of data; track agency.id) {
            <div 
              class="agency-card" 
              [class.selected]="agencySelected === agency"
              (click)="agencySelected = agency"
              tabindex="0"
              role="button"
              [attr.aria-pressed]="agencySelected === agency"
            >
              <div class="agency-icon">
                <mat-icon fontSet="material-icons-outlined">
                  {{ agencySelected === agency ? 'check_circle' : 'location_on' }}
                </mat-icon>
              </div>
              <div class="agency-info">
                <span class="agency-name">{{ agency.label }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <app-btn 
        [config]="cancelBtnConfig" 
        (click)="dialogRef.close()"> 
        Annuler
      </app-btn>
      <app-btn 
        [config]="confirmBtnConfig" 
        [disabled]="!agencySelected" 
        (click)="confirmAgency()">
        Confirmer
      </app-btn>
    </mat-dialog-actions>
    `,
    styleUrl: './dialog-choose-agency.component.scss'
})
export class DialogChooseAgencyComponent {
  public agencySelected: Agency | null = null;
  
  // Configuration des boutons
  public readonly cancelBtnConfig = DIALOG_CANCEL_BTN_CONFIG;
  public readonly confirmBtnConfig = DIALOG_CONFIRM_BTN_CONFIG;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Agency[], public dialogRef: MatDialogRef<DialogChooseAgencyComponent>) {
  }

  public confirmAgency() {
    this.dialogRef.close(this.agencySelected);
  }
}
